/* eslint-disable  @typescript-eslint/no-explicit-any */
const isDebugMode = (): boolean => {
  return localStorage.getItem('debug') === 'true';
};

const Logger = {
  log(message: string, ...optionalParams: any[]): void {
    if (isDebugMode()) {
      console.log(`[Universal][INFO] ${message}`, ...optionalParams);
    }
  },

  error(message: string, ...optionalParams: any[]): void {
    if (isDebugMode()) {
      console.error(`[Universal][ERROR] ${message}`, ...optionalParams);
    }
  },

  debug(message: string, ...optionalParams: any[]): void {
    if (isDebugMode()) {
      console.debug(`[Universal][DEBUG] ${message}`, ...optionalParams);
    }
  },
};

export { Logger };
